export default "__VITE_ASSET__BP4ZNfCg__"